import { tournamentsRoute } from "./apiroutes";
import customAxios from "./interceptor";

const AI_REQUEST_TIMEOUT = 120000;

export const getTournaments = ({
  page,
  limit,
  searchQuery,
  status,
  sortBy,
  sortOrder,
}) => {
  return async () => {
    try {
      const params = { page, limit };
      if (searchQuery) params.search = searchQuery;
      if (status && status !== "all") params.status = status;
      if (sortBy) params.sortBy = sortBy;
      if (sortOrder) params.sortOrder = sortOrder;

      const response = await customAxios.get(tournamentsRoute, { params });
      return { status: true, data: response.data };
    } catch (err) {
      return { status: false, message: err.message };
    }
  };
};

export const getTournamentById = (id) => {
  return async () => {
    try {
      const response = await customAxios.get(`${tournamentsRoute}/${id}`);
      return { status: true, data: response.data };
    } catch (err) {
      return { status: false, message: err.message };
    }
  };
};

export const createTournament = (data) => {
  return async () => {
    try {
      const response = await customAxios.post(tournamentsRoute, data, {
        timeout: AI_REQUEST_TIMEOUT,
      });
      return { status: true, data: response.data };
    } catch (err) {
      return { status: false, message: err.message };
    }
  };
};

export const updateTournament = (id, data) => {
  return async () => {
    try {
      const response = await customAxios.put(
        `${tournamentsRoute}/${id}`,
        data
      );
      return { status: true, data: response.data };
    } catch (err) {
      return { status: false, message: err.message };
    }
  };
};

export const regenerateTournamentQuestions = (id, data = {}) => {
  return async () => {
    try {
      const response = await customAxios.post(
        `${tournamentsRoute}/${id}/regenerate`,
        data,
        { timeout: AI_REQUEST_TIMEOUT }
      );
      return { status: true, data: response.data };
    } catch (err) {
      return { status: false, message: err.message };
    }
  };
};

export const regenerateTournamentQuestion = (id, questionId) => {
  return async () => {
    try {
      const response = await customAxios.post(
        `${tournamentsRoute}/${id}/questions/${questionId}/regenerate`,
        {},
        { timeout: AI_REQUEST_TIMEOUT }
      );
      return { status: true, data: response.data };
    } catch (err) {
      return { status: false, message: err.message };
    }
  };
};

export const generateAdditionalQuestion = (id) => {
  return async () => {
    try {
      const response = await customAxios.post(
        `${tournamentsRoute}/${id}/questions/generate`,
        {},
        { timeout: AI_REQUEST_TIMEOUT }
      );
      return { status: true, data: response.data };
    } catch (err) {
      return { status: false, message: err.message };
    }
  };
};

export const predictTournamentAnswers = (id) => {
  return async () => {
    try {
      const response = await customAxios.post(
        `${tournamentsRoute}/${id}/predict-answers`,
        {},
        { timeout: AI_REQUEST_TIMEOUT }
      );
      return { status: true, data: response.data };
    } catch (err) {
      return { status: false, message: err.message };
    }
  };
};

export const publishTournament = (id) => {
  return async () => {
    try {
      const response = await customAxios.patch(
        `${tournamentsRoute}/${id}/publish`,
        {},
        { timeout: AI_REQUEST_TIMEOUT }
      );
      return { status: true, data: response.data };
    } catch (err) {
      return { status: false, message: err.message };
    }
  };
};

export const unpublishTournament = (id) => {
  return async () => {
    try {
      const response = await customAxios.patch(
        `${tournamentsRoute}/${id}/unpublish`
      );
      return { status: true, data: response.data };
    } catch (err) {
      return { status: false, message: err.message };
    }
  };
};

export const setTournamentCorrectAnswers = (id, answers) => {
  return async () => {
    try {
      const response = await customAxios.post(
        `${tournamentsRoute}/${id}/correct-answers`,
        { answers }
      );
      return { status: true, data: response.data };
    } catch (err) {
      return { status: false, message: err.message };
    }
  };
};

export const deleteTournament = (id) => {
  return async () => {
    try {
      const response = await customAxios.delete(`${tournamentsRoute}/${id}`);
      return { status: true, data: response.data };
    } catch (err) {
      return { status: false, message: err.message };
    }
  };
};
